export default __webpack_public_path__ + "static/media/profile.41390b74.svg";